import { nanoid } from "nanoid";

/*
    Function that adds the projectData into the localstorage
    
    -> Get the previous items saved in localstorage and store it. 
    -> add the new projectData to the previous items
    -> now save the project items with new projectData into localstorage
    
*/
const addToLocalStorage = (projectData) => {
  // Get the previous items from localstorage
  const dbString = localStorage.getItem("db") || "[]";
  // Parse the string output to JSON
  const db = JSON.parse(dbString);
  // Concatinate(join) two array into a new array
  // Learn more about spread operator here,
  // TODO: add the link for spread operator
  const temp = [...db, projectData ];
  console.log(temp);
  // Save the new array into localstorage
  localStorage.setItem("db",JSON.stringify(temp));
};

/*
  Function used to give a structure for the projectdata
  and triggers the addToLocalStorage() function
*/
export const addProject = (projectName) => {
  // Create a project id with nanoid
  // TODO: add link for nanoid
  const projectId = nanoid(8);
  // Structure the project data
  const projectData = {
    projectId,
    projectName: projectName,
    projectBody: {
      notStarted: [],
      inProgress: [],
      completed: [],
    },
  };
  // Trigger addToLocalStorage
  addToLocalStorage(projectData);
};
